import React from "react";
import NumberFormat from 'react-number-format';

const DetailMoney = props => {
  return(
    <div className="col-md-4 mb-3">
      <label className="text-dark">{props.name}</label>
      <NumberFormat 
        thousandSeparator={true} 
        prefix={'$'}    
        className="form-control bg-light font-weight-lighter"
        style={{color: "#000000"}}
        value={props.field}
        disabled
      />
    </div>
  );
}

export default DetailMoney;